import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '科幻征文大赛获奖作品展示专题';
const baseUrl = '20240801KHZWZS';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/welcome`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'welcome',
      name: `${baseUrl}-welcome`,
      component: () => import('./pages/Welcome.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
        keepPosition: true,
      },
    },
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rule',
      name: `${baseUrl}-rule`,
      component: () => import('./pages/Rule.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'ruleTwo',
      name: `${baseUrl}-ruleTwo`,
      component: () => import('./pages/RuleTwo.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'ruleThree',
      name: `${baseUrl}-ruleThree`,
      component: () => import('./pages/RuleThree.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'ruleFour',
      name: `${baseUrl}-ruleFour`,
      component: () => import('./pages/RuleFour.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./pages/News.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'homeTwo',
      name: `${baseUrl}-homeTwo`,
      component: () => import('./pages/HomeTwo.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'homeThree',
      name: `${baseUrl}-homeThree`,
      component: () => import('./pages/HomeThree.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'detail',
      name: `${baseUrl}-detail`,
      component: () => import('./pages/Detail.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
